import { FC, ReactNode, useMemo, memo } from 'react'
import theme from '@utils/theme'
import { StyledWrapper } from './style'
interface ColumnProps {
  variant?: keyof JSX.IntrinsicElements
  children?: ReactNode
  alignItems?: 'center' | 'flex-start' | 'flex-end' | 'stretch' | 'baseline'
  justifyContent?:
    | 'center'
    | 'flex-start'
    | 'flex-end'
    | 'space-between'
    | 'space-around'
    | 'space-evenly'
  colGap?: number
  rowGap?: number
  styleColumn?: any
  bg?: keyof typeof theme.colors
  onClick?: () => void
}
const Column: FC<ColumnProps> = memo(
  ({ children, variant = 'div', ...restProps }) => {
    const Component = useMemo(
      () => StyledWrapper.withComponent(variant),
      [variant],
    )
    return <Component {...restProps}>{children}</Component>
  },
)

Column.displayName = 'Column'

export default Column
